export default __webpack_public_path__ + "static/media/product-price.f96a2536.svg";